import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchPendingAuditSaleReopenCount } from "../lib/fetch-pending-audit-sale-reopen-count.js";

/**
 * Contagem de auditorias pendentes de aprovação (badge da sidebar).
 * Atualiza no mount e ao mudar de rota.
 *
 * @param {{ enabled?: boolean }} [options]
 * @returns {{ count: number, loading: boolean, error: Error|null }}
 */
export function usePendingAuditCount({ enabled = true } = {}) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState(null);
  const location = useLocation();

  const refresh = useCallback(async () => {
    if (!enabled) {
      setCount(0);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    try {
      const next = await fetchPendingAuditSaleReopenCount();
      setCount(Number.isFinite(next) ? next : 0);
      setError(null);
    } catch (err) {
      console.error("Error fetching pending audit count:", err);
      setError(err instanceof Error ? err : new Error(String(err)));
      setCount(0);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    refresh();
  }, [refresh, location.pathname]);

  return { count, loading, error };
}
